import { Layout, Skeleton } from '@oneaudi/unified-web-alpha-components';
import { ItemListStyle } from '~/components/item-list/styles/item-list-style';

export const ListSkeleton = () => (
	<>
		{Array.from({ length: 6 }, (_, index) => (
			<ItemListStyle key={index}>
				<Layout direction="column" justify="space-between" rowGap="15px" className="details-wrapper">
					<Layout rowGap="15px" direction="column" className="checkbox-container">
						<Skeleton variant="oval" height={'20px'} width={'200px'} />
						<Skeleton variant="oval" height={'20px'} width={'100px'} />
						<Skeleton variant="oval" height={'20px'} width={'200px'} />
						<Skeleton variant="oval" height={'20px'} width={'100px'} />
					</Layout>
				</Layout>
				<div className="image-container">
					<div className="placeholder" aria-label="">
						<Skeleton variant="oval" height={'130px'} />
					</div>
				</div>
			</ItemListStyle>
		))}
	</>
);
